import { useCallback } from "react";
import useAppState from "./use-app-state";

const useJobCount = () => {
  const { numberValue: unseenJobCount, updateNumber } = useAppState({
    appStateType: "unseenJobCount",
    defaultValue: { numberValue: 0 },
  });

  const resetUnseenJobCount = useCallback(() => {
    updateNumber(0);
  }, [updateNumber]);

  const incrementUnseenJobCount = useCallback(() => {
    updateNumber(unseenJobCount + 1);
  }, [unseenJobCount, updateNumber]);

  return {
    unseenJobCount,
    resetUnseenJobCount,
    incrementUnseenJobCount,
  };
};

export default useJobCount;
